import { Result, Button } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { HELP_CENTER_URL } from '../../constants'

// the fallback UI which renders when an error is caught
export const ErrorFallBack = ({ error }) => {
  const errorStatus = error?.status === 401 ? 403 : error?.status // No 401 status in Result component so we use 403 instead for "unauthorized" style
  const statuses = [403, 404, 500]

  return (
    <div className='dashboard-result'>
      <Result
        status={statuses.includes(errorStatus) ? errorStatus : 'error'}
        title='An error occurred'
        subTitle={
          error?.response?.data?.err || // API error
          error?.message || // Axios error
          'Sorry, something went wrong. Please refresh the page or try again later.'
        }
        extra={
          <>
            <Link to='/' reloadDocument>
              <Button type='primary'>Go Home</Button>
            </Link>
            <Button type='secondary' onClick={() => window.location.reload(false)}>
              Refresh
            </Button>
          </>
        }
      />
      <a href={HELP_CENTER_URL} target='_blank' rel='noreferrer'>
        <Button type='link'>Need Help?</Button>
      </a>
    </div>
  )
}
